export enum RegionDetectMethod {
  PARAM = 'PARAM',
  STORAGE = 'STORAGE',
}
